import React from 'react';

interface DateFieldProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const sanitizeDateValue = (rawDate: string | undefined | null): string => {
  if (!rawDate) {
    return '';
  }

  const match = rawDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) {
    return '';
  }

  const [, year, month, day] = match;
  const yearNum = parseInt(year, 10);
  if (yearNum < 1900) {
    return '';
  }

  return `${year}-${month}-${day}`;
};

const DateField: React.FC<DateFieldProps> = ({
  id,
  value,
  onChange,
  disabled,
}) => {
  const safeDate = sanitizeDateValue(value);

  return (
    <input
      type="date"
      id={id}
      value={safeDate}
      onChange={onChange}
      className="cg-input"
      disabled={disabled}
    />
  );
};

export default DateField;
